import { Permisos_recepciones } from './../../../models/permisos_recepciones.model';
import { Component, ViewChild, ElementRef, TemplateRef } from "@angular/core";
import * as moment from 'moment'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material/dialog';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-permisos_recepciones",
    templateUrl: "./permisos_recepciones.component.html",
    styleUrls: ["./permisos_recepciones.component.css"],
    providers: [FormService]
})

export class Permisos_recepcionesComponent {
    @ViewChild('openModal', { static: true }) openModal: TemplateRef<any>;
    public rows = [];
    public actualRow;
    public permisos_recepciones: Permisos_recepciones;
    public form;
    public temp_perm;
    public matcher = new FormService();
    public maxDate;
    public selected;

    constructor(private fb: FormBuilder, private dialog: MatDialog) {
        this.maxDate = moment().toDate()

        this.form = new FormGroup({
            tipo_permiso: new FormControl(''),
            permiso: new FormControl(''),
            numero: new FormControl('', [Validators.min(0),Validators.pattern(/[0-9]*/)]),
            fecha: new FormControl({ value: '', disabled: true })


        })


        if (!JSON.parse(localStorage.getItem("permisos_recepciones"))) {
            localStorage.setItem("permisos_recepciones", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("permisos_recepciones"));

        }
        this.permisos_recepciones = { tipo_permiso: '', permiso: '', numero: 0, fecha: null };
        this.temp_perm = { tipo_permiso: '', permiso: '', numero: 0, fecha: null };

    }

    add_permisos_recepciones() {

        this.actualRow = localStorage.getItem("permisos_recepciones");
        this.rows = JSON.parse(this.actualRow);

        if (!this.form.value.permiso && !this.form.value.numero) {
            console.log("no se ingresaron datos");
        } else {
            this.rows = this.rows.concat({
                tipo_permiso: this.form.value.tipo_permiso,
                permiso: this.form.value.permiso,
                numero: this.form.value.numero,
                fecha: moment(this.form.value.fecha).format("DD/MM/YYYY")
            })
            localStorage.setItem("permisos_recepciones", JSON.stringify(this.rows));
            this.form.reset();
        }
    }
    delete_permisos_recepciones(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("permisos_recepciones", JSON.stringify(this.rows));
            }
        }
    }

    onChangeSelect(event) {
        let value = event.target.value;
        console.log(value);
    }
    get_permisos_recepciones(id) {
        console.log(id)
        for (let x = 0; x < this.rows.length; x++) {

            if (id == x) {
                this.temp_perm.id = id;
                this.temp_perm.tipo_permiso = this.rows[x].tipo_permiso;
                this.temp_perm.permiso = this.rows[x].permiso;
                this.temp_perm.numero = this.rows[x].numero;
                this.temp_perm.fecha = this.rows[x].fecha;


                console.log(this.temp_perm);
                this.dialog.open(this.openModal);

            }
        }
    }

    cleanData() {
        this.temp_perm = { tipo_permiso: '', permiso: '', numero: 0, fecha: null };

    }

    savepermisos_recepciones() {
        var id = this.temp_perm.id;
        console.log(this.temp_perm)
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("permisos_recepciones", JSON.stringify(this.rows));

                $("#antec_modal").modal("hide");
                this.actualRow = localStorage.getItem("permisos_recepciones");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({
                    tipo_permiso: this.temp_perm.tipo_permiso,
                    permiso: this.temp_perm.permiso,
                    numero: this.temp_perm.numero,
                    fecha: this.temp_perm.fecha


                })
                localStorage.setItem("permisos_recepciones", JSON.stringify(this.rows));
                //this.temp_perm.reset();
                this.dialog.closeAll();
            }
        }
    }

}